import store from './store.js'

export const saveState = ({ commit }, payload) => {
  commit('SAVED', payload)
}
export const toggleLoading = ({ commit, rootGetters }, payload) => {
  /* if (rootGetters.user.displayName && payload === false) {
    if (
      !rootGetters.organizationLoading &&
      !rootGetters.estimatesLoading &&
      !rootGetters.ratesLoading &&
      !rootGetters.redFlagLoading &&
      !rootGetters.rolesLoading &&
      !rootGetters.tasksLoading &&
      !rootGetters.teamLoading &&
      !rootGetters.userLoading
    ) {
      commit('LOADING', payload)
    }
  } else {
    commit('LOADING', payload)
  } */
  commit('LOADING', payload)
}
export const redirect = ({ commit }, payload) => {
  commit('REDIRECT', payload)
}
export const resetState = ({ state }) => {
  Object.assign(state, store)
}
